

















































import { PropType } from 'vue';
import Proxyable from '@/mixins/proxyable';
import validatable from '@/mixins/validatable';
import mixins from '@/utils/mixins';

export default mixins(validatable, Proxyable).extend({
  name: 'NullableCheckbox',

  props: {
    value: {
      type: Boolean as PropType<boolean | null>,
      default: null
    },
    dense: Boolean,
    id: String
  },

  computed: {
    checkboxIcon(): string {
      if (this.isInputIndeterminate) {
        return '$checkboxIndeterminate';
      } else if (this.isInputActive) {
        return '$checkboxOn';
      } else {
        return '$checkboxOff';
      }
    },
    checkboxId(): string {
      return this.id || `input-${(this as any)._uid}`;
    },

    computedColor(): string | undefined {
      if (!this.isInputActive) return undefined;
      if (this.color) return this.color;
      if (this.isDark && !this.appIsDark) return 'white';
      return 'primary';
    },

    validationState(): string | undefined {
      let state: string | undefined;
      if (this.isDisabled) {
        state = undefined;
      } else if (this.hasError && this.shouldValidate) {
        state = 'error';
      } else if (this.hasSuccess) {
        state = 'success';
      } else if (this.hasColor !== null) {
        state = this.computedColor;
      }
      return state;
    },

    isInputActive(): boolean {
      return this.internalValue === true;
    },

    isInputIndeterminate(): boolean {
      return this.internalValue === null;
    },

    internalValueStates(): (boolean | null)[] {
      return [null, true, false];
    }
  },
  methods: {
    onClick(e: Event) {
      this.onChange();
      this.$emit('click', e);
    },

    onChange() {
      const currentIndex = this.internalValueStates.indexOf(
        this.internalValue ?? null
      );

      // Calculate the next index and wrap around using modulo
      const nextIndex = (currentIndex + 1) % this.internalValueStates.length;
      this.internalValue = this.internalValueStates[nextIndex];
    },

    onFocus(e: FocusEvent) {
      this.isFocused = true;
      this.$emit('focus', e);
    },

    onBlur(e: FocusEvent) {
      this.isFocused = false;
      this.$emit('blur', e);
    },

    onKeydown(e: Event) {
      this.$emit('keydown', e);
    }
  }
});
